<template>
  <div style="width: 100%; heigh: 100%;">
    <div class="block table_searchbar">
      <el-row class="search-input-row">
        <span class="demonstration title">日期查询：</span>
        <el-date-picker
          style="width:220px"
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <span class="title">&nbsp; &nbsp; 机组：</span>
        <el-select
          style="max-width: 180px;"
          filterable
          clearable
          v-model="searchForm.department"
          popper-class="select_width"
          size="small"
          maxlength="16"
          placeholder="机组"
          @keyup.enter.native="search"
        >
          <el-option :title="item.name" v-for="item in organizationList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
        &nbsp; &nbsp; &nbsp; &nbsp;
        <el-button type="primary" icon="el-icon-search" size="mini" @click="search">查询</el-button>
        <el-button icon="el-icon-search" size="mini" @click="exportList"
          >导出
          <i class="el-icon-download el-icon--right"></i>
        </el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
      </el-row>
    </div>

    <el-table :data="tableData" stripe style="width: 100%;" border max-height="736" :cell-style="warningCellStyle">
      <el-table-column prop="organizationName" label="机组" min-width="120"></el-table-column>
      <el-table-column prop="deviceTypeName" label="设备类型" min-width="150"></el-table-column>
      <el-table-column prop="deviceCount" label="设备数" min-width="100"></el-table-column>
      <el-table-column label="剩余产能（小时）/ 总产能（小时）">
        <el-table-column :label="item.calDate" v-for="(item, index) in tableHeaders" :key="item.calDate" min-width="100">
          <template slot-scope="scope">
            <!-- <div v-if="scope.row.list[index].remainingHour<0" style="background-color:red;">
                    </div>
                    <span v-else>{{ scope.row.list[index].remainingHour }}</span> -->
            <div @click="toDetail(scope.row, item.calDate)">{{ scope.row.list[index].remainingHour }}/{{ scope.row.list[index].workHour }}</div>
            <!-- /{{scope.row.deviceCount * (item.endHour - item.beginHour) * item.isWork}} -->
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-dialog title="产能明细" :visible.sync="dialogFormVisible">
      <el-table :data="dailyData">
        <el-table-column property="productionBatchCode" label="工单号" width="150"></el-table-column>
        <el-table-column property="splitStatus" :formatter="parseStatus" label="工单状态" width="150"></el-table-column>
        <el-table-column property="procedureName" label="工序" width="200"></el-table-column>
        <el-table-column property="deviceCode" label="设备编码" width="200"></el-table-column>
        <el-table-column property="deviceName" label="设备名称"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { resolve, reject } from "q";

export default {
  name: "CapacityOfProduction",
  data: () => {
    return {
      W: false,
      fristLoad: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchForm: {
        department: null
      },
      dateRange: [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)), new Date()],
      addForm: {
        imei: "",
        address: ""
      },
      editForm: {
        id: "",
        imei: "",
        address: ""
      },
      tableData: [],
      tableHeaders: null,
      currentRow: {},
      tableTotalPage: 100,
      tableCurrentPage: 1,
      permission: JSON.parse(localStorage.getItem("permission")),
      organizationList: null,
      /*** 绑定设备相关 **/
      remoteLoading: false,
      restaurants: [], //设备下拉列表
      equipmentData: [],
      equipmentQuery: "",
      dialogFormVisible: false,
      dailyData: []
    };
  },
  mounted: function() {
    this.initTable();
    this.loadOrganizationList();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },
  methods: {
    search: function() {
      let temp;
      var dateRange = this.dateRange;
      if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
        this.$message.warning("请选择完整的时间区间");
        return;
      }

      let t1 = new Date(dateRange[0]).getTime();
      let begin = commonUtils.timestampToDate(t1);

      let t2 = new Date(dateRange[1]).getTime();
      let end = commonUtils.timestampToDate(t2);

      //if((dateRange[1].getTime() - dateRange[0].getTime()) > 1000 * 3600 * 24 * 31){
      //this.$message.warning("时间区间不可超过1个月");
      //return
      //}

      this.$RequestUtil.get({
        url: "/api/analysis/getCapacityOfProduction",
        type: "sync",
        params: {
          beginDate: begin,
          endDate: end,
          factoryModelWorkshopId: this.searchForm.department
        },
        success: res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            this.tableData = res.data.list;
            this.tableTotalPage = res.totalPages;
            this.tableHeaders = res.data.calendar;
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },
    initTable: function() {
      this.search();
    },
    async loadOrganizationList(name) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/factoryModel/getWorkShopList",
        type: "sync",
        params: {}
      });
      this.organizationList = res.data;
    },
    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.search();
    },
    clearSearch() {
      this.dateRange = [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)), new Date()];
    },
    parseDate: function(rowData) {
      if (rowData.gmtCreate != null) {
        let dateString = commonUtils.timestampToDate(rowData.gmtCreate, false);
        return dateString;
      }
    },
    parseStatus(rowDate) {
      var json = {};
      switch (
        rowDate.splitStatus //0-未排产 1-已排产 2-已派工 3-生产中 4-已完成 5-已关闭
      ) {
        case 0:
          json.text = "未排产";
          break;
        case 1:
          json.text = "已排产";
          break;
        case 2:
          json.text = "已派工";
          break;
        case 3:
          json.text = "生产中";
          break;
        case 4:
          json.text = "已完成";
          break;
        case 5:
          json.text = "已关闭";
          break;
      }
      return json.text;
    },
    warningCellStyle: function({ row, column, rowIndex, columnIndex }) {
      let styleJson = {};

      if (columnIndex > 2) {
        var ss = row.list[columnIndex - 3].remainingHour;
        if (row.list[columnIndex - 3].remainingHour < 0) {
          //return {
          //background: "rgb(255,45,45,0.2)",
          //color: "rgb(255,45,45)",
          //};
          styleJson.background = "rgb(255,45,45,0.2)";
          styleJson.color = "rgb(255,45,45)";
        }
        styleJson.cursor = "pointer";
        return styleJson;
      }
    },
    exportList() {
      let temp;
      var dateRange = this.dateRange;
      if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
        this.$message.warning("请选择完整的时间区间");
        return;
      }

      let t1 = new Date(dateRange[0]).getTime();
      let begin = commonUtils.timestampToDate(t1);

      let t2 = new Date(dateRange[1]).getTime();
      let end = commonUtils.timestampToDate(t2);

      let params = {
        beginDate: begin,
        endDate: end,
        orgId: this.searchForm.department,
        token: localStorage.getItem("token")
      };

      let str = "?";
      for (let p in params) {
        if (params[p] || params[p] === 0) {
          str += `${p}=${params[p]}&`;
        }
      }

      if (str.endsWith("&")) {
        str = str.slice(0, str.length - 1);
        window.location.href = "/api/analysis/exportCapacityOfProduction" + str;
      }
    },
    toDetail(row, calDate) {
      this.dialogFormVisible = true;
      this.$RequestUtil.get({
        url: "/api/analysis/getDailyProductionLoadDetail",
        type: "sync",
        params: {
          beginDate: calDate,
          endDate: calDate
        },
        success: res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            this.dailyData = res.data;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
      //this.$router.push({path: '/ProductionLoadDetail',name:'ProductionLoadDetail',param:{groupId: row.groupId, deviceTypeId:row.deviceTypeId,calDate:calDate}, query: {groupId: row.groupId, deviceTypeId:row.deviceTypeId,calDate:calDate}});
    },
    beforeRouteUpdate(to, from, next) {
      next();
    }
  }
};
</script>
<style scoped>
.cell_warning {
  background-color: red;
}
.table_searchbar {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
}
.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.addForm .value {
  display: inline-block;
  width: 280px;
  text-align: center;
}
.addForm .title {
  width: 70px;
  text-align: right;
  display: inline-block;
}
.page {
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 1380px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/Production/CapacityOfProduction.vue